// This is the only file that is allowed to import styled-components
/* eslint-disable no-restricted-imports */
import type { DefaultTheme, FlattenInterpolation, ThemedStyledProps } from 'styled-components';
import { useTheme as useThemeOriginal } from 'styled-components';

import { type Theme } from '@app/theme';

export { default, css, keyframes, ThemeProvider, createGlobalStyle, withTheme } from 'styled-components';
export type { ThemedCssFunction, StyledProps, CSSObject, CSSProperties } from 'styled-components';

export type CssDeclaration<P extends object> = FlattenInterpolation<ThemedStyledProps<P, DefaultTheme>>;

export const useTheme = useThemeOriginal as () => Theme;
